<template>
  <div class="text-center">
    <div class="icon icon-xl icon-muted mb-12" v-html="require('@/assets/img/icons/search-data.svg')" />
    <div class="text-muted">{{ captionText }}</div>
  </div>
</template>

<script>
  export default {
    props: {
      captionText: {
        type: String,
        default: ''
      }
    }
  }
</script>